<template>
	<div class="page">
		<!-- 搜索 -->
		<div class="search-box">
			<input v-model="keyword" type="search" class="search-input" placeholder="请输入症状的1-2个字" />
			<div class="search-btn" @click="goSearch">搜索</div>
		</div>
		<!-- 身体部位 -->
		<div class="tabs">
			<div :class="current == 0 ? 'tab active' : 'tab'" @click="changeTab(0)">身体部位</div>
			<div :class="current == 1 ? 'tab active' : 'tab'" @click="changeTab(1)">部位列表</div>
		</div>
		<!-- 列表 -->
		<div class="content">
			<body-part v-if="current == 0" :sex="sex" :type="type" :direction="direction" @change="changeBody"
				@clickPart="showDisease"></body-part>
			<body-list v-else :sex="sex" :type="type" @clickPart="showDisease"></body-list>
			<div v-if="current == 0" class="left">哪里不舒服点哪里</div>
		</div>
		<!-- 症状列表 -->
		<popup class="popup" v-model="show" position="right">
			<symptom-list :partId="partId" :partName="partName" :sex="sex" :type="type"
				@clickSymptom="clickSymptom"></symptom-list>
		</popup>
		<!-- 结果 -->
		<popup v-model="result" style="top: 35px;max-height: 70vh;" :overlay-style="{'top': '35px'}" position="top">
			<div class="result-list">
				<div class="result-item" v-for="(item, index) in symptomList" :key="index" @click.stop="clickSymptom(item.id)">
					<div>{{item.symptomName}}</div>
					<icon name="arrow"></icon>
				</div>
			</div>
		</popup>
	</div>
</template>

<script>
	import Vue from 'vue'
	import BodyPart from '@/components/BodyPart'
	import BodyList from '@/components/BodyList'
	import SymptomList from '@/components/SymptomList'
	import {
		Popup,
		Toast,
		Icon
	} from 'vant'
	import 'vant/lib/popup/style'
	import 'vant/lib/toast/style'
	import {
		searchSymptom
	} from '@/api/guidance'
	import wx from 'weixin-js-sdk'

	Vue.use(Toast)

	export default {
		name: 'Guidance',
		components: {
			BodyPart,
			BodyList,
			SymptomList,
			Popup,
			Icon
		},
		data() {
			return {
				current: 0,
				sex: 1, // 1男2女
				type: 1, // 1成人0小孩
				direction: 0,
				partId: null,
				partName: null,
				show: false,
				keyword: null,
				result: false,
				symptomList: []
			}
		},
		created() {
			document.title = '自查自诊'
		},
		methods: {
			changeTab(index) {
				// 修改菜单
				this.current = index
			},
			changeBody(value, type) {
				// 修改显示的身体
				if (type == 0) {
					this.sex = value
				} else if (type == 1) {
					this.type = value
				} else if (type == 2) {
					this.direction = value
				}
			},
			showDisease(partId, partName) {
				// 点击部位显示病症
				this.partId = partId
				this.partName = partName
				this.show = !this.show
			},
			goSearch() {
				if (this.keyword) {
					// 请求搜索
					searchSymptom({
						peopleType: this.getType(),
						symptomName: this.keyword
					}).then(res => {
						this.symptomList = res.result
						this.result = true
					})
				} else {
					Toast('请输入关键词')
				}
			},
			getType() {
				if (this.sex == 1 && this.type == 0) {
					//男儿童
					return 2;
				} else if (this.sex == 2 && this.type == 0) {
					//女儿童
					return 4;
				} else if (this.sex == 2 && this.type == 1) {
					//女人
					return 3;
				} else {
					//男人
					return 1;
				}
			},
			clickSymptom(id) {
				// 点击的症状ID
				let type = this.getType();
				if (window.__wxjs_environment === 'miniprogram') {
					wx.miniProgram.navigateTo({
						url: '/pages/other/guidance/main?id=' + id + '&type=' + type
					})
				} else {
					uni.navigateTo({
						url: '/pages/other/guidance/main?id=' + id + '&type=' + type
					});
					location.href = 'medical://symptom?id=' + id + '&type=' + type;
				}
			}
		}
	}
</script>

<style scoped>
	.page {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100vh;
		overflow: hidden;
	}

	.search-box {
		display: flex;
		flex-direction: row;
		align-items: center;
		border-radius: 5px;
		overflow: hidden;
		margin: 0 10px 10px 10px;
		flex-shrink: 0;
	}

	.search-box .search-input {
		flex: 1;
		text-align: center;
		line-height: 30px;
		padding: 0 10px;
		color: black;
		background-color: whitesmoke;
		border: none;
		border-radius: 5px;
	}

	.search-box .search-btn {
		margin-left: 10px;
		color: #0063aa;
	}

	.tabs {
		display: flex;
		flex-direction: row;
		align-items: center;
		border-radius: 5px;
		overflow: hidden;
		margin: 0 10px;
		flex-shrink: 0;
	}

	.tabs .tab {
		flex: 1;
		text-align: center;
		line-height: 30px;
		color: black;
		background-color: whitesmoke;
	}

	.tabs .tab.active {
		color: white;
		background-color: #0063aa;
	}

	.content {
		position: relative;
		flex: 1;
		width: 100%;
		overflow: hidden;
		background: white;
	}

	.content .left {
		position: absolute;
		left: 22px;
		top: 40px;
		z-index: 9;
		width: 20px;
		font-size: 14px;
		color: gray;
	}

	.list {
		border-top: 1px solid #f2f2f2;
		padding: 0 10px;
	}

	.list .row {
		padding: 5px 0;
		border-bottom: 1px solid #f2f2f2;
	}

	.popup {
		width: 70%;
		height: 100%;
	}

	.result-item {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 10px 15px;
		color: #666666;
		background-color: white;
		border-bottom: 1px solid #f2f2f2;
	}

	.result-item div {
		flex: 1;
	}

	.result-item img {
		width: 6px;
		height: 10px;
	}
</style>